import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedTab: "creation",
    selectedProduct: [],
    selectedUserProfiles: [],
    criteriaSelectionView: false,
    selectedCriteria: "",
    selectedCriterionOptions: {},
    navigatedFromStudies: false,
    actionStandards: [],
};

export const autoDeckReportStore = createSlice({
    name: "autoDeckReportStore",
    initialState,
    reducers: {
        loadSelectedTabState: (state, action) => {
            state.selectedTab = action.payload;
        },
        loadSelectedProductState: (state, action) => {
            state.selectedProduct = action.payload;
        },
        loadSelectedUserProfilesState: (state, action) => {
            state.selectedUserProfiles = action.payload;
        },
        loadCriteriaSelectionViewState: (state, action) => {
            state.criteriaSelectionView = action.payload;
        },
        loadSelectedCriteriaState: (state, action) => {
            state.selectedCriteria = action.payload;
        },
        loadSelectedCriterionOptionsState: (state, action) => {
            state.selectedCriterionOptions = action.payload;
        },
        loadNavigatedFromStudiesState: (state, action) => {
            state.navigatedFromStudies = action.payload;
        },
        loadActionStandardsState: (state, action) => {
            state.actionStandards = action.payload;
        },
        resetAutoDeckReportStore: () => initialState,
    },
});

export const { loadSelectedTabState, loadSelectedProductState, loadSelectedUserProfilesState, loadCriteriaSelectionViewState, loadSelectedCriteriaState, loadSelectedCriterionOptionsState, loadNavigatedFromStudiesState, loadActionStandardsState, resetAutoDeckReportStore } = autoDeckReportStore.actions;

export default autoDeckReportStore.reducer;
